module.exports = __webpack_public_path__ + "img/Digrab_Carrousel_1.daaa7708.png";